'use client';

import { useEffect } from 'react';
import { SectionHeader } from '../components/SectionHeader';
import { AdminDataTable } from '../components/AdminDataTable';
import { StatusBadge } from '../components/StatusBadge';
import type { AdminUserRow } from '../context/AdminAllDataContext';
import { useAdminAllData } from '../context/AdminAllDataContext';
import { Button } from '@/core/presentation/components/ui/Button';
import { Plus } from 'lucide-react';

function formatDateTime(iso: string) {
  return new Date(iso).toLocaleString('pt-BR');
}

const columns = [
  { key: 'id', header: 'ID' },
  { key: 'displayName', header: 'Nome', render: (r: AdminUserRow) => r.displayName },
  { key: 'email', header: 'Email', render: (r: AdminUserRow) => r.email ?? '—' },
  { key: 'phone', header: 'Telefone' },
  {
    key: 'phone_verified',
    header: 'Telefone verificado',
    render: (r: AdminUserRow) => <StatusBadge status={r.phone_verified ? 'ativo' : 'pendente'} />,
  },
  { key: 'planDisplayLabel', header: 'Plano', render: (r: AdminUserRow) => r.planDisplayLabel },
  { key: 'company_name', header: 'Empresa', render: (r: AdminUserRow) => r.company_name ?? '—' },
  {
    key: 'created_at',
    header: 'Criado em',
    render: (r: AdminUserRow) => formatDateTime(r.created_at),
  },
];

export default function UsersPage() {
  const {
    state: { enrichedUsers, usersLoading, usersError },
    events: { refreshUsers },
  } = useAdminAllData();

  useEffect(() => {
    void refreshUsers();
  }, [refreshUsers]);

  return (
    <div>
      <SectionHeader
        title="Usuários"
        subtitle="Gerenciamento de usuários cadastrados"
        actions={
          <Button className="bg-admin-navy hover:bg-admin-navy-mid text-white">
            <Plus className="h-4 w-4 mr-1" />
            Novo usuário
          </Button>
        }
      />
      {usersError ? (
        <p className="text-sm text-destructive mb-4" role="alert">
          {usersError}
        </p>
      ) : null}
      {usersLoading && enrichedUsers.length === 0 ? (
        <p className="text-sm text-admin-text-secondary py-8">Carregando usuários…</p>
      ) : (
        <AdminDataTable
          data={enrichedUsers}
          columns={columns}
          searchKeys={['displayName', 'email', 'phone', 'company_name', 'planDisplayLabel']}
        />
      )}
    </div>
  );
}
